<template>
  <v-card flat color="transparent">
    <v-img
      :lazy-src="image.lazySrc"
      :src="image.src"
      :height="imageHeight"
    ></v-img>
    <v-container data-aos="fade">
      <h1 class="text-center">{{title}}</h1>
      <h5>My story</h5>
      <p>
        Born in the southwest of France, I was raised in the heart of French food culture, which
        is rooted in bringing people together to enjoy the art of good food.
      </p>
      <p>
        My mum - a real inspiration and a chef by trade, and my entire family - all amazing cooks
        have been cultivating the art of cooking and passing it down to me. I learned watching
        them and I have always loved experimenting in the kitchen and cooking for others.
      </p>
      <p class="mb-8">
        Coming from a family of farmers, I was intrinsically drawn to a sustainable way of
        cooking from a young age. I created Chef Naturelle to share my love for convivial,
        seasonal and natural cuisine.
      </p>
      <h5>My cooking</h5>
      <p>
        Naturally curious, I seek to highlight taste, novelty and adventure with every bite.
        Having trained as a naturopathic chef, I specialise in whole food plant-based cooking.
      </p>
      <p class="mb-8">
        I find inspiration in the healing benefits of seasonal cuisine and take pleasure in
        using raw and unrefined ingredients. My conscious approach to cooking allows me creative
        freedom and the opportunity to connect with those I am cooking for, the producers I use,
        and the ingredients from which I draw inspiration.
      </p>
      <h5>My promise</h5>
      <p>
        In my mission to educate and guide others in their journey to reconnecting with food,
        I combine my professional knowledge and genuine passion for cooking to make nutritional
        dishes accessible to all.
      </p>
      <p>
        I delight in creating sincere and responsible cuisine. When I am not using produce I have
        foraged, or grown in my organic allotment, I strive to source products from local
        producers who share the same principles as myself.
      </p>
      <p>
        From teaching to cooking for retreats or private events, I always favour seasonal, local
        and organic agriculture: the starting point to all great meals!
      </p>
      <p>
        Whether it be through providing you my catering services or cooking classes, I am thrilled
        for you to embark on this journey — let's reconnect with food!
        Until then, please do not hesitate to
        <a href="mailto:contact@chefnaturelle.com">write</a> to me,
        <router-link to="blog">read more</router-link> about holistic cuisine, or
        <a href="https://www.instagram.com/chef_naturelle/" target="_blank">connect</a>.
      </p>
      <p class="mb-8">
        Based in Hertford, UK, I travel around England, France and beyond.
      </p>
    </v-container>
  </v-card>
</template>

<script>
import {
  VCard,
  VContainer,
  VImg,
} from 'vuetify/lib'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    VCard,
    VContainer,
    VImg,
  },
  computed: {
    headerStyle() {
      return {
        'font-size': this.$vuetify.breakpoint.xsOnly ? '15px!important': '27px'
      }
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '250px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '600px'
        case 'xl': return '800px'
      }
      return '800px'
    },
    nameStyle() {
      return {
        'margin-top': '10px',
        'margin-right': '10px',
        'margin-bottom': this.$vuetify.breakpoint.xsOnly ? '30px' : '100px',
      }
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  data: () => ({
    image: require('@/assets/images/about-banner1.jpg?vuetify-preload'),
    title: 'Meet Stéphanie',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
        .description('I am Stéphanie, a true believer that food can bring happiness! Born in the south west of France,'
          + ' I was brought up in the heart of French food culture which is all about bringing people together to'
          + ' enjoy the art of good food.')
        .image(`${window.location.origin}${this.image.src}`)
        .title(this.title)
        .build()
  }
}
</script>

<style scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}

h5 {
  padding-bottom: 10px;
}
</style>
